import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inline-block text-left text-gray-800 relative" }
const _hoisted_2 = { class: "rounded-md shadow-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "-mr-1 ml-2 h-5 w-5 text-white",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_24 = {
  key: 1,
  class: "max-h-60 p-2 text-white overflow-y-auto"
}
const _hoisted_25 = {
  key: 0,
  class: "relative"
}
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 3,
  class: ""
}
const _hoisted_32 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { key: 4 }
const _hoisted_39 = ["src"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["title"]
const _hoisted_42 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
            () => {
              !_ctx.disabled ? (_ctx.isMenuOpen = !_ctx.isMenuOpen) : '';
            }
          ),
          type: "button",
          class: _normalizeClass(["inline-flex items-center justify-between rounded-md shadow-md h-10 px-4 py-4 text-sm leading-5 font-medium text-white hover:text-gray-300 focus:outline-none focus:border-primary focus:shadow-outline-primary active:bg-gray-600 active:text-gray-800 transition ease-in-out duration-150 btn-focus", _ctx.getBackgroundColor(900)]),
          id: "options-menu",
          "aria-haspopup": "true",
          "aria-expanded": "true"
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (_ctx.hasCalendar)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  (_ctx.calendarOptions.mode == 'date')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        (_ctx.calendarOptions.isRange)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.selectedDate.start, "DD.MM.YYYY")) + " - " + _toDisplayString(_ctx.formatDate(_ctx.selectedDate.end, "DD.MM.YYYY")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.selectedDate, "DD.MM.YYYY")), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.calendarOptions.mode == 'dateTime')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        (_ctx.calendarOptions.isRange)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.selectedDate.start, "DD.MM.YYYY HH:mm")) + " - " + _toDisplayString(_ctx.formatDate(_ctx.selectedDate.end, "DD.MM.YYYY HH:mm")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.selectedDate, "DD.MM.YYYY HH:mm")), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.calendarOptions.mode == 'time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        (_ctx.calendarOptions.isRange)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.selectedDate.start, "HH:mm")) + " - " + _toDisplayString(_ctx.formatDate(_ctx.selectedDate.end, "HH:mm")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.selectedDate, "HH:mm")), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  (_ctx.selectedSubMenuItem.id != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (
                    _ctx.selectedSubMenuItem.nameDE != null &&
                    _ctx.selectedSubMenuItem.nameDE.length > 0
                  )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: _ctx.selectedSubMenuItem.description
                            }, _toDisplayString(_ctx.selectedSubMenuItem.nameDE), 9, _hoisted_15))
                          : (
                    _ctx.selectedSubMenuItem.nameEN != null &&
                    _ctx.selectedSubMenuItem.nameEN.length > 0
                  )
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                title: _ctx.selectedSubMenuItem.description
                              }, _toDisplayString(_ctx.selectedSubMenuItem.nameEN), 9, _hoisted_16))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                title: _ctx.selectedSubMenuItem.description
                              }, _toDisplayString(_ctx.selectedSubMenuItem.name), 9, _hoisted_17))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (
                    _ctx.selectedItem.nameDE != null &&
                    _ctx.selectedItem.nameDE.length > 0
                  )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: _ctx.selectedItem.description
                            }, _toDisplayString(_ctx.selectedItem.nameDE), 9, _hoisted_19))
                          : (
                    _ctx.selectedItem.nameEN != null &&
                    _ctx.selectedItem.nameEN.length > 0
                  )
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                title: _ctx.selectedItem.description
                              }, _toDisplayString(_ctx.selectedItem.nameEN), 9, _hoisted_20))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                title: _ctx.selectedItem.description
                              }, _toDisplayString(_ctx.selectedItem.name), 9, _hoisted_21))
                      ]))
                ]))
          ]),
          _hoisted_22
        ], 2)
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["max-h-96 origin-top-right absolute mx-auto mt-2.5 mb-10 rounded-md shadow-2xl text-sm z-40", _ctx.hasCalendar ? 'w-auto' : 'w-56'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rounded-md", 
            _ctx.hasCalendar ? _ctx.getBackgroundColor(900) : _ctx.getBackgroundColor(900)
          ]),
                role: "menu",
                "aria-orientation": "vertical",
                "aria-labelledby": "options-menu"
              }, [
                (_ctx.hasCalendar)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_VueDatePicker, {
                        id: "manual",
                        modelValue: _ctx.selectedVuePickerDate,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedVuePickerDate) = $event)),
                          _ctx.handleSelectedDate
                        ],
                        dark: "",
                        "show-now-button": "",
                        locale: "de",
                        format: "dd.MM.yyyy",
                        cancelText: "Abbrechen",
                        selectText: "Auswählen",
                        inline: "",
                        "hide-navigation": ['time'],
                        range: _ctx.calendarOptions?.isRange ?? true,
                        "now-button-label": "Heute auswählen"
                      }, null, 8, ["modelValue", "range", "onUpdate:modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_ctx.hasFilterInput)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_SearchField, {
                              onSetText: _ctx.setSearchFilter,
                              activateOnChange: true
                            }, null, 8, ["onSetText"])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                        return (_openBlock(), _createElementBlock("div", { key: item }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["flex items-start justify-between text-left p-2 my-1 w-full hover:shadow-md hover:text-gray-300 rounded-md", 
                    item.id == _ctx.selectedItem.id && !_ctx.isMenu
                      ? _ctx.getHighlightColor(true, 700)
                      : ''
                  ]),
                              onClick: ($event: any) => (_ctx.selectItem(item))
                            }, [
                              (item.nameDE != null && item.nameDE.length > 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    title: item.description
                                  }, _toDisplayString(item.nameDE), 9, _hoisted_28))
                                : (item.nameEN != null && item.nameEN.length > 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      title: item.description
                                    }, _toDisplayString(item.nameEN), 9, _hoisted_29))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      title: item.description
                                    }, _toDisplayString(item.name), 9, _hoisted_30)),
                              (item.data != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    (item.id == _ctx.selectedItem.id)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_34))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_37))
                                  ]))
                                : (_ctx.iconSrc != '' && item.id != '-1')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _createElementVNode("img", {
                                        class: "h-5",
                                        src: _ctx.iconSrc + item.name + '.png'
                                      }, null, 8, _hoisted_39)
                                    ]))
                                  : _createCommentVNode("", true)
                            ], 10, _hoisted_27),
                            (item.data != null && item.id == _ctx.selectedItem.id)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["w-full -right-full top-1/2 z-40 absolute mx-auto rounded-md shadow-lg text-sm p-2", _ctx.getBackgroundColor(900)])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (subItem) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: subItem.id,
                                      class: ""
                                    }, [
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["flex items-start justify-start text-left p-2 my-1 w-full hover:shadow-md hover:text-gray-300 rounded-md", 
                        subItem.id == _ctx.selectedSubMenuItem.id && !_ctx.isMenu
                          ? _ctx.getHighlightColor(true, 700)
                          : ''
                      ]),
                                        onClick: ($event: any) => (_ctx.selectSubMenuItem(subItem))
                                      }, [
                                        (
                          subItem.nameDE != null && subItem.nameDE.length > 0
                        )
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              title: subItem.description
                                            }, _toDisplayString(subItem.nameDE), 9, _hoisted_41))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              title: subItem.description
                                            }, _toDisplayString(subItem.name), 9, _hoisted_42))
                                      ], 10, _hoisted_40)
                                    ]))
                                  }), 128))
                                ], 2))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_away, _ctx.onClickAway]
  ])
}